export const SET_WINDOW_INDEX = Symbol('SET_WINDOW_INDEX');

/**
 * @description
 * Gets the user data required for every page on the site
 *
 * @returns {{}}
 */
export function setWindowIndex (index) {

	return {
		type: SET_WINDOW_INDEX,
		index
	};
}
